<template>
    <div class="header" v-if="!isRedirect">
        <Header>
            <div class="header_wrapper">
                <div class="left">
                    <img src="/img/logo.png" alt="logo" width="144" height="72" @click="$router.push('/index')">
                </div>
                <nav class="center">
                    <router-link class="nav_item" :to="{ path: '/index'}" active-class="active" analysis-name="线上课程_Tab_首页">首页</router-link>
                    <!-- <router-link class="nav_item" :to="{ path: '/home'}" active-class="active">直播课程</router-link> -->
                    <router-link class="nav_item" :to="{ path: '/records'}" active-class="active" analysis-name="线上课程_Tab_业务提升">业务提升</router-link>
                    <router-link class="nav_item" :to="{ path: '/expand'}" active-class="active" analysis-name="线上课程_Tab_市场拓展">市场拓展</router-link>
                    <router-link class="nav_item" :to="{ path: '/service-center/all'}" target='_blank' active-class="active" v-if="showServiceCenter">iCourt企业法律服务中台</router-link>
                    <!--          <router-link class="nav_item" :to="{ path: '/lives'}" active-class="active">橙三直播</router-link>-->
                    <!-- <router-link class="nav_item" :to="{ path: '/download'}" active-class="active">APP下载</router-link> -->
                </nav>
                <div class="right">
                    <Input prefix="md-search" placeholder="请输入关键字查询" clearable class="class-search" @on-enter="searchEnter(searchText)" v-model="searchText" />
                    <Dropdown v-if="isLogin" @on-click="handleProfile">
                        <Avatar size="large" :src="avatar||`/img/avatar-male.svg`"/>
                        <DropdownMenu slot="list">
                            <DropdownItem name="logout">登出</DropdownItem>
                        </DropdownMenu>
                    </Dropdown>
                    <VuiButton v-else class="btn" type="warning" round @click.native="login">登录</VuiButton>
                </div>
            </div>
        </Header>
        <!-- <div class="notice" v-if="!isNewAddress">该域名即将迁移，访问新的地址<a :href="redirectUrl">点击跳转</a></div> -->
    </div>
</template>
<script>
import { mapState } from 'vuex'
import { FISCAL_TAX, CCC } from '@/constant/constants'

export default {
  data () {
    return {
      isRedirect: sessionStorage.getItem('redirectType') === FISCAL_TAX || sessionStorage.getItem('redirectType') === CCC,
      isNewAddress: location.host.indexOf('school.alphalawyer.cn') >= 0,
      redirectUrl: this.$config.courseFilesDomain,
      searchText: this.$router.currentRoute.query.keyword || '',
    }
  },
  computed: {
    ...mapState('app', {
      isLogin: state => state.isLogin,
      avatar: state => state.userinfo.avatar,
      showServiceCenter: state => state.userinfo.showServiceCenter,
    }),
  },
  methods: {
    searchEnter (searchText) {
    //   this.$router.push(`/class-search-result?keyword=${searchText}`)
      this.$router.push(`/global-search?keyword=${searchText}`)
    },
    handleProfile (val) {
      if (val === 'logout') {
        this.$store.dispatch('app/quit')
      }
    },
    login () {
      this.$router.push({ name: 'Login' })
    },
  },
}
</script>
<style lang="scss">
    .header {
        position: sticky;
        top: 0;
        z-index: 10000;
        .ivu-input {
            background: #F6F7F8;
            border-radius: 21px;
            border: 1px solid #F0F1F2;
            height: 40px;
            font-size: 13px;
            &::placeholder {
                color: #b4b4b4
            }
            &:focus {
                color: #333333 !important;
                background: #FFFFFF;
                border: 1px solid #FA8919 !important;
            }
        }
        .ivu-icon.ivu-icon-md-search {
            color: #b4b4b4;
            line-height: 40px;
        }

        .class-search {
            display: inline-block;
            width: 270px;
            margin-right: 40px;
            .ivu-input{
                color: #212121;
                padding-right: 30px;
                padding-left: 40px;
                &:focus{
                    box-shadow:inherit;
                    border: none;
                }
            }
            .ivu-input-prefix {
                left: 10px;
            }
            .ivu-input-icon {
                outline: none;
                line-height: 40px;
                right: 10px;
                color: #d6d6d6;
            }
        }
        .notice {
            height: 30px;
            line-height: 30px;
            background: #ed6c00;
            text-align: center;
            font-size: 14px;
            color: #fff;

            a {
                margin-left: 4px;
                color: #fff;
                text-decoration: underline;
            }
        }
    }

    .ivu-layout-header {
        background: #fff;
        border-bottom: 1px solid #ebebeb;
        width: 100%;
        z-index: 11;
        min-width: 1280px;
        height: 72px;

        .header_wrapper {
            position: relative;
            display: flex;
            margin: auto;
            width: 1200px;
            .left {
                display: flex;
                align-items: center;
                margin-right: 56px;
                img {
                    cursor: pointer;
                }

                .title {
                    margin-left: 16px;
                    font-size: 20px;
                }

                .sub_title {
                    margin-left: 16px;
                    font-size: 12px;
                    color: #868688;
                }
            }

            .center {
                display: flex;
                flex: 1;
                .nav_item {
                    position: relative;
                    top: 4px;
                    margin: 0 16px;
                    cursor: pointer;
                    transition: all .3s;
                    font-size: 16px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #666666;
                    &:hover {
                        color: #FA8919;
                    }

                    &.active {
                        font-weight: 600;
                        color: #171717;

                        &::after {
                            content: '';
                            display: block;
                            position: absolute;
                            width: 24px;
                            border-radius: 2px;
                            height: 4px;
                            background: #FA8919;
                            top: 48px;
                            left: 50%;
                            transform: translateX(-50%);
                        }
                    }
                }
            }

            .right {
                margin-left: 70px;

                .vui-btn {
                    background: #FA8919;
                    border-radius: 16px;
                    font-size: 12px;
                    font-family: PingFangSC-Medium, PingFang SC;
                    font-weight: 500;
                    color: #FFFFFF;
                    border: none;
                    &:hover {
                        background: #FA9A2A;
                    }
                }
            }
        }
    }
</style>
